// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__16i0k","boxTitle":"Qualiphy_boxTitle__ezTxO","box":"Qualiphy_box__1b08Y","toggleWrap":"Qualiphy_toggleWrap__2eUWJ"};